import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import PayPalButtonsWrapper from './PayPalButtonsWrapper';
import Stripe from './Stripe';
import ApiService from '../../services/ApiService';
import { useSelector } from "react-redux";
import { decrypt } from "../../utils/crypto";

function Index() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { userData } = useSelector(state => state.auth);

    const location = useLocation();

    const [activeGateway, setActiveGateway] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);

    const getActiveGatewayDetails = async () => {
        try {
            /////////////////// Api call ///////////////////////
            var response = await new ApiService().GET(`/get-active-payment-gateway`);
            console.log("get-active-payment-gateway ", response.data);

            if (response.data.status === '1') {
                const dec_client_id = decrypt(response.data.client_id, process.env.REACT_APP_CRYPTO_KEY);
                setClientId(dec_client_id);
                setActiveGateway(response.data.gateway);

                if (response.data.gateway === 'stripe') {
                    const payload = {
                        userid: userData.id,
                        amount: location.state.amount
                    };
                    const response_2 = await new ApiService().POST(`/create-stripe-payment-intent`, payload);
                    console.log("create-stripe-payment-intent ", response_2.data);
                    if (response_2.data.status === '1') {
                        setClientSecret(response_2.data.clientSecret);
                    }
                }
            } else {
                console.log(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getActiveGatewayDetails();
    }, [])


    return (<>
        {activeGateway === 'paypal' && clientId !== null && (
            <PayPalButtonsWrapper
                payment_type={location.state.payment_type}
                amount={location.state.amount}
                clientId={clientId}
                chat_plan_id={location.state?.chat_plan_id ? location.state.chat_plan_id : ""}
            />
        )}

        {activeGateway === 'stripe' && clientId !== null && clientSecret !== null && (
            <Stripe
                payment_type={location.state.payment_type}
                amount={location.state.amount}
                StripePublishKey={clientId}
                ClientSecret={clientSecret}
                chat_plan_id={location.state?.chat_plan_id ? location.state.chat_plan_id : ""}
            />
        )}
    </>)
}

export default Index